<script>
// import Vue from 'vue'
// Import UI components
import Layout from '@layouts/report.vue'
// import Grid from '@components/grid.vue'



// Import ThirdParty UI Components
import MultiAxisChart from '@components/charts/multiAxisChart.vue'
// Import component
import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'
// Import Deps
import axios from 'axios'
import moment from 'moment'
import _ from 'underscore'
import ECharts from 'vue-echarts'

// Import helpers
// import { sortData, pipe } from '@utils/helpers.js'

// export const remapData = (data) =>
//   data.map((obj, index) => {
//     return { value: obj[key1], name: obj[key2] }
//   })

export const pipe = (...functions) => (value) => {
  return functions.reduce((currentValue, currentFunction) => {
    return currentFunction(currentValue)
  }, value)
}

function getDates(startDate, endDate) {
  var dateArray = []
  var currentDate = moment(startDate)
  var stopDate = moment(endDate)
  while (currentDate <= stopDate) {
    dateArray.push(
      moment(currentDate)
        .format('DDMMMYY')
        .toUpperCase()
    )
    currentDate = moment(currentDate).add(1, 'days')
  }
  return dateArray
}

const formatUsageData = (data, xKey, yKey) => {
  // Data needs to be sorted for eChats
  data = data.sort((a, b) => {
    var x = a[xKey]
    var y = b[xKey]
    return x < y ? -1 : x > y ? 1 : 0
  })
  // Group the data as it broken down by carrier
  const grouped = _.groupBy(data, (obj) => moment(obj[xKey]).format('DDMMMYY'))
  // reduce the data for each day 'group'
  const returnData = []
  Object.keys(grouped).forEach((key) => {
    returnData.push({
      date: key,
      value: _.reduce(
        grouped[key],
        (memo, obj) => {
          return memo + obj[yKey]
        },
        0
      ),
    })
  })

  const finalData = returnData.map((obj) => {
    const x = {
      name: moment(obj.date).toDate(),
      value: [moment(obj.date).format('YYYY/MM/DD'), obj.value],
    }
    return x
  })
  return finalData
}

export default {
  page() {
    return {
      title: 'Usage Report',
      meta: [
        {
          name: 'description',
          content: ``,
        },
      ],
    }
  },
  components: {
    Layout,

    MultiAxisChart,
    Loading,
  },
  props: {},
  data() {
    return {
      chartData: [],
      chartOptions: {
        tooltip: {
          trigger: 'axis',

          axisPointer: {
            type: 'cross',
            animation: false,
          },
        },
        dataZoom: [
          {
            show: true,
            start: null,
            end: null,
            type: 'inside',
          },
        ],
        legend: {
          data: ['Flights', 'Checked Passengers', 'Checked Baggage'],

          top: 40,
        },
        xAxis: {
          type: 'time',
          splitLine: {
            show: false,
          },
        },
        yAxis: [
          {
            type: 'value',
            name: 'Pax & Bags',
            splitLine: {
              show: true,
            },
          },

          {
            type: 'value',
            offset: 0,
            name: 'Flts',
            // max: 8,
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: 'Flights',
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
            type: 'line',
            showSymbol: false,
            hoverAnimation: true,
            data: [],
            yAxisIndex: 1,
            itemStyle: {
              color: '#b9bcbe',
            },
            lineStyle: {
              width: 0,
            },
            areaStyle: {
              color: new ECharts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#e3e4e5',
                },
                {
                  offset: 1,
                  color: '#b9bcbe',
                },
              ]),
            },
          },
          {
            name: 'Checked Passengers',
            // areaStyle: {},
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
            type: 'line',
            showSymbol: false,
            hoverAnimation: false,
            data: [],
            markPoint: {
              data: [
                {
                  type: 'max',
                  name: 'Hightest Passenger Count',
                },
                {
                  type: 'min',
                  name: 'Lowest Passenger Count',
                },
              ],
              label: {
                textStyle: {
                  color: '#fff',
                  fontWeight: 600,
                },
              },
            },
            markLine: {
              data: [{ type: 'average', name: 'Average Passenger Count' }],
              label: {
                textStyle: {
                  fontSize: 18,
                  fontWeight: 600,
                },
              },
            },
            // sampling: 'average',
            itemStyle: {
              color: '#00747b',
            },
            lineStyle: {
              width: 0,
            },

            areaStyle: {
              color: new ECharts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#00f2c5',
                },
                {
                  color: '#00878f',
                  offset: 0.25,
                },
                {
                  offset: 1,
                  color: '#00747c',
                },
              ]),
            },
          },
          {
            name: 'Checked Baggage',
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
            type: 'line',
            showSymbol: false,
            hoverAnimation: false,
            data: [],

            lineStyle: {
              width: 0,
            },
            itemStyle: {
              color: '#00464b',
              shadowBlur: 200,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
            areaStyle: {
              shadowBlur: 200,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
              color: new ECharts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#00747c',
                },
                {
                  offset: 1,
                  color: '#00464b',
                },
              ]),
            },
          },
        ],
      },
      lastUpdated: [{ type: 'usageTotals', timestamp: null }],
      isLoading: false,
      error: null,
      sideBarVisible: true,
      params: {},
      sortKey: 'StdDate',
      paramsSchema: [
        {
          fieldType: 'MultiSelect',
          placeholder: 'Select Carriers',
          multi: true,
          value: null,
          name: 'carrier',
          label: 'Carriers',
        },
      ],
    }
  },

  computed: {
    carrierChoice() {
      return this.$store.getters['auth/getCarrierChoice']
    },

    dateRange() {
      return this.$store.getters['report/getSelectedDateRange']
    },
    datesArray() {
      return getDates(
        this.dateRange.startDate,
        this.dateRange.endDate
      ).reverse()
    },
  },
  watch: {
    chartData: {
      immediate: true,
      handler(data) {
        this.chartOptions.series[0].data = data[0]
        this.chartOptions.series[1].data = data[1]
        this.chartOptions.series[2].data = data[2]
      },
    },

    dateRange: {
      deep: true,
      immediate: true,
      handler(dateRange) {
        this.getData()
      },
    },
    params: {
      deep: true,
      handler() {
        this.getData()
      },
    },
    selectedKey: {
      handler() {
        this.getData()
      },
    },
  },
  beforeCreate() {
    this.$store.dispatch('report/SET_SELECTED_DATE_RANGE', {
      startDate: moment().add(-6, 'month'),
      endDate: moment(),
    })
  },
  mounted() {
    // this.getData()
    this.paramsSchema[0].options = this.carrierChoice
  },
  methods: {
    formatUsageData: formatUsageData,
    moment(date, format) {
      return moment(date).format(format)
    },
    sortData(data) {
      return data.sort((a, b) => {
        var x = a[this.sortKey]
        var y = b[this.sortKey]
        return x < y ? -1 : x > y ? 1 : 0
      })
    },
    getData() {
      this.isLoading = true

      this.error = null
      //   Setup Report Params
      const startDate = moment(this.dateRange.startDate).format('DDMMMYY')
      const endDate = moment(this.dateRange.endDate).format('DDMMMYY')
      const carriers =
        this.params && this.params.carrier
          ? this.params.carrier.join(',')
          : 'all'
      //   @@TODO - Config file for webapi address!!
      axios
        .get(
          `${this.$config.apiBaseUrl}flightStats/carrier/${carriers}/start/${startDate}/end/${endDate}`
        )
        .then((response) => {
          const data = response.data.Results[0]
          // Update the timestamp
          const usageTotals = this.lastUpdated.findIndex(
            (obj) => obj.type === 'usageTotals'
          )
          this.lastUpdated[usageTotals].timestamp = response.data.Timestamp
          const data1 = this.formatUsageData(data, 'StdDate', 'PaxCkd')
          const data2 = this.formatUsageData(data, 'StdDate', 'BagsCkd')
          const data3 = this.formatUsageData(data, 'StdDate', 'FlightsHandled')
          this.chartData = [data3, data1, data2]
        })
        .catch((error) => {
          this.error = error.response
          console.log('here ---> ', error)
        })
        .finally(() => (this.isLoading = false))
    },
  },
}
</script>

<template>
  <Layout
    :params-schema="paramsSchema"
    :params="params"
    :last-updated="lastUpdated"
    :error="error"
  >
    <div class="mr-1 mt-1 ml-1 full">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-10">
              <h5 class="card-title">Usage Report</h5>
              <p
                >This report shows the total flights, passengers and baggage for
                a given date range. Use your mouse wheel to zoom. Click and hold
                to drag the chart forward or backwards in time.</p
              >
            </div>
            <div class="col-4 text-right"></div>
            <div class="col-2 text-right"> </div>
          </div>

          <MultiAxisChart
            id="usageChart"
            :chart-data="chartData"
            :chart-options="chartOptions"
          ></MultiAxisChart>
        </div>
      </div>
    </div>
    <Loading></Loading>
  </Layout>
</template>

<style scoped></style>
